var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        "enter-class": "slide-fade-enter",
        "enter-active-class": "slide-fade-enter-active",
      },
    },
    [
      _c(
        "div",
        { staticClass: "p-4" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _vm.editing
                  ? [
                      _c(
                        "i",
                        {
                          staticClass:
                            "material-icons clickable text-primary mr-3",
                          on: { click: _vm.stopEditing },
                        },
                        [_vm._v("keyboard_backspace")]
                      ),
                      _vm._v(" "),
                      _c("h3", { staticClass: "d-inline mr-2" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.sectionTitle) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                    ]
                  : [
                      _c("h3", [
                        _c("span", [
                          _c(
                            "i",
                            {
                              staticClass:
                                "material-icons clickable text-primary mr-3",
                              on: { click: _vm.backToSelect },
                            },
                            [_vm._v("arrow_back")]
                          ),
                        ]),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.sectionTitle) +
                            "\n            "
                        ),
                        _c("span", { staticClass: "bold text-primary" }, [
                          _vm._v(" " + _vm._s(_vm.sharedText) + " "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mt-3 pl-4 row align-items-center",
              attrs: { id: "new-trigger" },
            },
            [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("global.words.when")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("automation-dropdown", {
                attrs: {
                  id: "trigger",
                  items: _vm.triggersByShareType,
                  disabled: _vm.editing,
                  placeholder: _vm.$t("automations.selectTrigger"),
                  triggers: "",
                },
                model: {
                  value: _vm.trigger,
                  callback: function ($$v) {
                    _vm.trigger = $$v
                  },
                  expression: "trigger",
                },
              }),
              _vm._v(" "),
              !_vm.isEmpty(_vm.trigger["trigger-arguments"])
                ? _c("trigger-arguments", {
                    key: _vm.getKey(_vm.trigger),
                    attrs: { trigger: _vm.trigger, editing: _vm.editing },
                    model: {
                      value: _vm.triggerArguments,
                      callback: function ($$v) {
                        _vm.triggerArguments = $$v
                      },
                      expression: "triggerArguments",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldShowActionSelect
                ? [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "automations.boardLevel.performTheFollowingTask"
                          )
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("automation-dropdown", {
                      attrs: {
                        id: "action",
                        items: _vm.actions,
                        placeholder: _vm.$t("automations.selectAction"),
                      },
                      model: {
                        value: _vm.action,
                        callback: function ($$v) {
                          _vm.action = $$v
                        },
                        expression: "action",
                      },
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.isEmpty(_vm.action["action-arguments"]) &&
              _vm.shouldShowActionSelect
                ? _c("action-arguments", {
                    key: _vm.getKey(_vm.action),
                    ref: "actionArgComponent",
                    attrs: {
                      "trigger-arguments": _vm.triggerArguments,
                      trigger: _vm.trigger,
                      action: _vm.action,
                      editing: _vm.editing,
                    },
                    model: {
                      value: _vm.actionArguments,
                      callback: function ($$v) {
                        _vm.actionArguments = $$v
                      },
                      expression: "actionArguments",
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.shouldShowSave
            ? _c(
                "email-editor-templates",
                {
                  staticClass: "justify-content-end slide-up",
                  attrs: {
                    "only-action-button": !_vm.shouldShowTemplateControls,
                    "raw-html": _vm.currentEmailIfActive,
                    subject: _vm.emailSubject,
                  },
                  on: {
                    clear: _vm.clearTemplate,
                    selected: _vm.handleTemplateSelect,
                  },
                },
                [
                  _c(
                    "simple-button",
                    {
                      attrs: {
                        type: "primary btn-sm",
                        loading: _vm.saving,
                        "loading-status": _vm.savingStatus,
                      },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.words.save")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }